import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-text-divider',
    imports: [CommonModule, MatDividerModule, MatIconModule],
    templateUrl: './text-divider.component.html',
    styleUrls: ['./text-divider.component.scss']
})
export class TextDividerComponent {
  @Input() clickable: boolean = false;
  @Input() opened: boolean = true;
  @Output() openedChange = new EventEmitter<boolean>();

  toggleOpened() {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }
}
